import { render } from "./FabricWeightComp.vue?vue&type=template&id=90533c78&scoped=true&ts=true"
import script from "./FabricWeightComp.vue?vue&type=script&lang=ts"
export * from "./FabricWeightComp.vue?vue&type=script&lang=ts"

import "./FabricWeightComp.vue?vue&type=style&index=0&id=90533c78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90533c78"]])

export default __exports__